import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class KnowledgeId extends IdValueObject {
  static create(value: string): KnowledgeId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeId(value);
  }
}
